<agr-form-dialog
  [formGroup]="formGroup"
  [data]="data"
  (confirm)="confirm($event)"
  (cancel)="cancel()"
  (alt)="alt()"
  #ngForm="ngForm"
>
  <div class="dialog spacing--margin-top">
    <div>
      <mat-form-field class="full-width-field">
        <mat-label>{{ 'name' | translate }}</mat-label>
        <input
          matInput
          formControlName="name"
          [placeholder]="'name' | translate"
          data-test="editTreatment-name"
        />
      </mat-form-field>
    </div>
    <mat-form-field class="full-width-field">
      <mat-label>{{ 'objective' | translate }}</mat-label>
      <mat-select
        formControlName="objective"
        [placeholder]="'objective' | translate"
        data-test="editTreatment-objective"
      >
        @for (objective of data.objectives; track objective) {
          <mat-option [value]="objective.value"> {{ objective.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <div class="flex--row flex--gutter">
      <div class="flex__child">
        <mat-form-field class="full-width-field">
          <mat-label>{{ 'frequency' | translate }}</mat-label>
          <input
            matInput
            agrNumber
            formControlName="frequency"
            [step]="1"
            autocomplete="off"
            data-test="editTreatment-frequency"
          />
        </mat-form-field>
      </div>
    </div>
    <div class="flex--row flex--gutter">
      <div class="flex__child">
        <div class="mat-slide-group">
          <mat-slide-toggle
            color="primary"
            formControlName="shouldUseAreaInHectaresManual"
            data-test="edit-cropfield-shouldUseAreaInHectaresManual"
            >{{ 'shouldUseAreaInHectaresManual' | translate }}
          </mat-slide-toggle>
        </div>
      </div>
      <div class="flex__child">
        <mat-form-field class="full-width-field">
          <mat-label>{{ 'hectare' | translate }}</mat-label>
          <input
            matInput
            agrNumber
            maxlength="7"
            formControlName="areaInHectaresManual"
            [min]="0"
            [step]="0.01"
            data-test="editTreatment-areaInHectaresManual"
          />
        </mat-form-field>
      </div>
    </div>
    <div class="flex--row flex--gutter">
      <mat-form-field class="flex__child--auto">
        <mat-label>{{ 'moment' | translate }}</mat-label>
        <textarea
          matInput
          formControlName="moment"
          [cdkTextareaAutosize]="true"
          [cdkAutosizeMinRows]="3"
          data-test="editTreatment-moment"
        ></textarea>
      </mat-form-field>
      <mat-form-field class="flex__child--auto">
        <mat-label>{{ 'pointOfAttention' | translate }}</mat-label>
        <textarea
          matInput
          formControlName="pointOfAttention"
          [cdkTextareaAutosize]="true"
          [cdkAutosizeMinRows]="3"
          data-test="editTreatment-pointOfAttention"
        ></textarea>
      </mat-form-field>
    </div>
    @if (isGbmTreatment()) {
      <div class="flex--row flex--gutter">
        <div class="flex__child">
          <div class="mat-slide-group">
            <mat-slide-toggle
              (change)="shouldUseDriftReductionToggle($event)"
              color="primary"
              formControlName="shouldUseCompanySettingsDriftReduction"
              data-test="edit-cropfield-shouldUseCompanySettingsDriftReduction"
              >{{ 'shouldUseCompanySettingsDriftReduction' | translate }}
            </mat-slide-toggle>
          </div>
        </div>
        <div class="flex__child">
          <mat-form-field class="full-width-field">
            <mat-label>{{ 'driftReduction' | translate }}</mat-label>
            <mat-select
              [disabled]="formGroup.controls.shouldUseCompanySettingsDriftReduction.value"
              formControlName="driftReduction"
              [placeholder]="'driftReduction' | translate"
              data-test="editTreatment-driftReduction"
            >
              @for (percentage of driftReductions; track percentage) {
                <mat-option [value]="percentage"> {{ percentage }}%</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    }
    <div class="flex--row flex--gutter">
      @if (data.treatmentType === TreatmentType.Fertilization) {
        <div class="flex__child">
          <div class="mat-slide-group">
            <mat-slide-toggle
              color="primary"
              formControlName="isAnExecutedTreatment"
              data-test="editTreatment-executed-treatment"
              >{{ 'isAnExecutedTreatment' | translate }}</mat-slide-toggle
            >
          </div>
        </div>
      }
      <div class="flex__child">
        <mat-form-field class="full-width-field">
          <mat-label>{{ 'period' | translate }}</mat-label>
          <mat-select formControlName="periodId" data-test="editTreatment-period-id">
            @for (period of salesOrderPeriods; track period) {
              <mat-option [value]="period.id">
                {{ period.name }}
                ({{ period.startDispatchFrom | agrDate: 'shortDate' }} {{ 'until' | translate }}
                {{ period.deliverBefore | agrDate: 'shortDate' }})
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    @if (aidAdvicesFormArray.errors && ngForm.submitted) {
      <p class="notification notification-error">
        <mat-icon>error</mat-icon>
        {{ 'treatmentNoProductError' | translate }}
      </p>
    }
    @if (!everyAidAdviceValid()) {
      <div class="notification notification-error">
        <mat-icon>error</mat-icon>
        {{ 'invalidCropAidAdvice' | translate }}
      </div>
    }
  </div>
  <ng-container>
    <div class="button-title">
      <h3 class="text--h5">{{ 'cropAids' | translate }}</h3>
      @if (!addingProduct) {
        <button
          mat-flat-button
          color="primary"
          type="button"
          (click)="addProduct()"
          [disabled]="!!editedProduct || editedProduct === 0"
          data-test="editTreatment-addProduct"
        >
          <mat-icon>add</mat-icon>
          {{ 'addCropAid' | translate }}
        </button>
      }
    </div>
  </ng-container>
  @if (addingProduct) {
    <ng-container formArrayName="aidAdvices">
      <div
        class="flex--container"
        [formGroupName]="aidAdvicesFormArray.length - 1"
        data-test="editTreatment-productForm"
      >
        <div class="flex--row flex--gutter">
          <div class="flex__child flex__child-3">
            <mat-form-field class="full-width-field">
              <mat-label>{{ 'productAlt' | translate }}</mat-label>
              <input
                type="text"
                matInput
                formControlName="cropAidId"
                [matAutocomplete]="newProductAutocomplete"
                #newProductInput
                data-test="editTreatment-productFilter"
                (blur)="checkProduct()"
              />
              <mat-autocomplete
                #newProductAutocomplete="matAutocomplete"
                (optionSelected)="selectProduct($event.option.value, true)"
                [displayWith]="displayProduct()"
              >
                @for (option of filteredProducts$ | async; track option) {
                  <mat-option [value]="option.id" data-test="editTreatment-productOption">
                    {{ option.name }}
                    {{ getAdmissionNumberString(option.cropProtection?.admissions) }}
                  </mat-option>
                }
              </mat-autocomplete>
              @if (showPhosphateWorkingCoefficientWarning) {
                <p class="notification notification-warning">
                  <mat-icon>warning</mat-icon
                  >{{ 'fertilizerWorkingCoefficientWarning' | translate }}
                </p>
              }
              @if (!isCropAidValid(selectedProduct)) {
                <p class="notification notification-error">
                  <mat-icon>warning</mat-icon>{{ getCropAidInvalidMessage(selectedProduct) }}
                </p>
              }
            </mat-form-field>
          </div>
          <div class="flex__child">
            <mat-form-field class="full-width-field">
              <mat-label>
                {{ 'advicedDosage' | translate }}
                {{ selectedProduct ? ' (' + selectedProduct.unitOfMeasurement + ')' : '' }}
              </mat-label>
              <input
                matInput
                agrNumber
                [placeholder]="
                  ('advicedDosage' | translate) +
                  (selectedProduct ? ' (' + selectedProduct.unitOfMeasurement + ')' : '')
                "
                formControlName="dosage"
                data-test="editTreatment-productDosage"
                [step]="0.001"
                autocomplete="off"
              />
            </mat-form-field>
          </div>
        </div>
        @if (selectedProduct?.isFertilizer && formGroup.controls.periodId.value) {
          <div class="flex--row flex--gutter">
            <div class="flex__child">
              <div class="mat-slide-group">
                <mat-slide-toggle
                  color="primary"
                  formControlName="shouldUseNitrogenEffectivityManual"
                  data-test="edit-cropfield-shouldUseNitrogenEffectivityManual"
                  >{{ 'shouldUseNitrogenEffectivityManual' | translate }}
                </mat-slide-toggle>
              </div>
            </div>
            <div class="flex__child">
              <mat-form-field class="full-width-field">
                <mat-label>{{ 'nitrogenEffectivity' | translate }}</mat-label>
                <input
                  matInput
                  agrNumber
                  formControlName="nitrogenEffectivity"
                  [min]="0"
                  [step]="0.01"
                  data-test="editTreatment-nitrogenEffectivity"
                />
              </mat-form-field>
            </div>
          </div>
        }
        <app-legal-restriction-info
          [cropAid]="selectedProduct"
          [cropId]="cropId"
          [province]="province"
        ></app-legal-restriction-info>
        <div class="flex--row flex--gutter flex--justify-end spacing--margin-bottom">
          <div class="flex__child--none">
            <button mat-flat-button (click)="cancelAddingProduct()" type="button">
              {{ 'cancel' | translate }}
            </button>
            <button
              mat-flat-button
              color="primary"
              (click)="doneAddingProduct()"
              [disabled]="aidAdvicesFormArray.invalid"
              data-test="done-adding-product"
              type="button"
            >
              {{ 'add' | translate }}
            </button>
          </div>
        </div>
      </div>
    </ng-container>
  }
  @if (cropAidAdvices.length) {
    <mat-list
      data-test="editTreatment-products"
      class="layout--margin-negative-horizontal spacing--margin-bottom"
      formArrayName="aidAdvices"
    >
      @for (cropAidAdvice of cropAidAdvices; track cropAidAdvice; let i = $index) {
        <ng-container [formGroupName]="i">
          @for (
            selectedCropAid of [findProduct(aidAdvicesFormArray.at(i).get('cropAidId').value)];
            track $index
          ) {
            @if (editedProduct !== i) {
              <mat-list-item data-test="editTreatment-productRow">
                @if (isCropAidValid(selectedCropAid)) {
                  <mat-icon matListItemIcon>receipt</mat-icon>
                }
                @if (!isCropAidValid(selectedCropAid)) {
                  <mat-icon matListItemIcon color="warn">error</mat-icon>
                }
                <h2 matListItemTitle>
                  {{ selectedCropAid ? selectedCropAid.name : '' }}
                  {{ getAdmissionNumberString(selectedCropAid?.cropProtection?.admissions) }}
                </h2>
                <!--
                        INFO: Showing Prices should/could be re-enabled in the future. They have been hidden
                        per story: https://dev.azure.com/agrifirm/Next%20Platform/_backlogs/backlog/Team%20Arable/Stories/?workitem=61336
                        <p matLine>
                          <ng-container *ngIf="selectedCropAid.cropProtection?.activeIngredient">
                            {{ selectedCropAid.cropProtection?.activeIngredient }},
                          </ng-container>
                          {{ getIndicativePrice(selectedCropAid.indicativePrice) | agrCurrency: 'EUR' }}
                        </p> -->
                @if (!isCropAidValid(selectedCropAid)) {
                  <p
                    matListItemLine
                    class="text-color--warn-500 background-color--warn-50 spacing--padding-half-left spacing--padding-half-right"
                  >
                    {{ getCropAidInvalidMessage(selectedCropAid) }}
                  </p>
                }
                <span matListItemLine
                  >{{ aidAdvicesFormArray.at(i).get('dosage').value | agrNumber }}
                  {{ selectedCropAid ? selectedCropAid.unitOfMeasurement : '' }}</span
                >
                <div class="flex--container treatment-actions" matListItemMeta>
                  <ng-container>
                    <button
                      mat-icon-button
                      color="primary"
                      type="button"
                      (click)="editProduct(i)"
                      [disabled]="addingProduct || (editedProduct && editedProduct !== i)"
                      data-test="editTreatment-editProduct"
                    >
                      <mat-icon>edit</mat-icon>
                    </button>
                    <button
                      mat-icon-button
                      color="primary"
                      type="button"
                      (click)="removeProduct(i)"
                      [disabled]="addingProduct || (editedProduct && editedProduct !== i)"
                      data-test="editTreatment-removeProduct"
                    >
                      <mat-icon>delete</mat-icon>
                    </button>
                  </ng-container>
                </div>
              </mat-list-item>
            }
            @if (editedProduct === i) {
              <div class="layout--margin-horizontal spacing--margin-top">
                <div class="flex--row flex--gutter" data-test="editTreatment-editForm">
                  <div class="flex__child flex__child-3">
                    <mat-form-field class="full-width-field">
                      <mat-label>{{ 'productAlt' | translate }}</mat-label>
                      <input
                        type="text"
                        [placeholder]="'productAlt' | translate"
                        matInput
                        formControlName="cropAidId"
                        [matAutocomplete]="editProductAutocomplete"
                        #newProductInput
                        data-test="editTreatment-productFilter"
                        (blur)="checkProduct()"
                      />
                      <mat-autocomplete
                        #editProductAutocomplete="matAutocomplete"
                        (optionSelected)="selectProduct($event.option.value)"
                        [displayWith]="displayProduct()"
                      >
                        @for (option of filteredProducts$ | async; track option) {
                          <mat-option [value]="option.id" data-test="editTreatment-productOption">
                            {{ option.name }}
                            {{ getAdmissionNumberString(option.cropProtection?.admissions) }}
                          </mat-option>
                        }
                      </mat-autocomplete>
                      @if (!isCropAidValid(selectedCropAid)) {
                        <p class="notification notification-error">
                          <mat-icon>warning</mat-icon
                          >{{ getCropAidInvalidMessage(selectedCropAid) }}
                        </p>
                      }
                    </mat-form-field>
                  </div>
                  <div class="flex__child">
                    <mat-form-field class="full-width-field">
                      <mat-label>
                        {{ 'advicedDosage' | translate }}
                        {{ selectedCropAid ? '(' + selectedCropAid.unitOfMeasurement + ')' : '' }}
                      </mat-label>
                      <input
                        matInput
                        agrNumber
                        [placeholder]="
                          ('advicedDosage' | translate) +
                          ' (' +
                          selectedCropAid?.unitOfMeasurement +
                          ')'
                        "
                        formControlName="dosage"
                        data-test="editTreatment-productDosage"
                        [step]="0.001"
                        autocomplete="off"
                      />
                    </mat-form-field>
                  </div>
                </div>
              </div>
            }
          }
          @if (editedProduct === i) {
            <div class="layout--margin-horizontal">
              @if (cropAidAdvice.isFertilizer) {
                <div class="flex--row flex--gutter">
                  <div class="flex__child">
                    <div class="mat-slide-group">
                      <mat-slide-toggle
                        color="primary"
                        formControlName="shouldUseNitrogenEffectivityManual"
                        data-test="edit-cropfield-shouldUseNitrogenEffectivityManual"
                        >{{ 'shouldUseNitrogenEffectivityManual' | translate }}
                      </mat-slide-toggle>
                    </div>
                  </div>
                  <div class="flex__child">
                    <mat-form-field class="full-width-field">
                      <mat-label>{{ 'nitrogenEffectivity' | translate }}</mat-label>
                      <input
                        matInput
                        agrNumber
                        formControlName="nitrogenEffectivity"
                        [min]="0"
                        [step]="0.01"
                        data-test="editTreatment-nitrogenEffectivity"
                      />
                      <span matSuffix class="form-field-suffix--text">%</span>
                    </mat-form-field>
                  </div>
                </div>
              }
            </div>
          }
          @if (editedProduct === i) {
            <div class="layout--margin-horizontal">
              <div class="flex--row flex--gutter flex--justify-end spacing--margin-bottom">
                <div class="flex__child--none">
                  <button
                    mat-flat-button
                    type="button"
                    color="primary"
                    (click)="doneEditingProduct()"
                    [disabled]="aidAdvicesFormArray.invalid"
                    data-test="done-adding-product"
                  >
                    {{ 'ok' | translate }}
                  </button>
                </div>
              </div>
            </div>
          }
          <div class="layout--margin-horizontal">
            <app-legal-restriction-info
              [cropAid]="cropAidAdvice"
              [cropId]="cropId"
              [province]="province"
            ></app-legal-restriction-info>
          </div>
        </ng-container>
      }
    </mat-list>
  }
  <div class="spacing--margin-top">
    @if (isFertilizationTreatment) {
      <app-fertilization-table
        [tableReportData$]="tableReportData$"
        (headerClick)="toggleFertilizationDetails()"
        style="display: block"
      ></app-fertilization-table>
    }
  </div>
</agr-form-dialog>
